import { ETSY_URL, HERO_BG_URL, trackEtsy } from "../data/site";
import { ArrowUpRight } from "lucide-react";

/**
 * Reusable final CTA. Pass variant="fashion" on fashion pages,
 * "heritage" (default) on the heritage page.
 */
export default function FinalCTA({ variant = "heritage" }) {
  const isFashion = variant === "fashion";

  const overline = isFashion ? "Ready to shop" : "The Invitation";
  const heading = isFashion
    ? ["Step into the", "Kendi wardrobe."]
    : ["Bring culture", "into your space."];
  const body = isFashion
    ? "Vintage-inspired silhouettes, modern tailoring, secure Etsy checkout. Ships worldwide from Melbourne."
    : "A throw on the sofa. A basket by the door. A mask on the wall. Small choices that turn a house into a home with heritage.";
  const ctaLabel = isFashion ? "Shop Dresses on Etsy" : "Explore Full Collection on Etsy";
  const trackSection = isFashion ? "fashion_final_cta" : "heritage_final_cta";
  const footnote = isFashion
    ? "Etsy secure checkout · Fast shipping from Australia"
    : "Free worldwide shipping over AUD 150";

  return (
    <section
      data-testid={isFashion ? "fashion-final-cta-section" : "final-cta-section"}
      className="relative py-32 md:py-44 px-6 md:px-12 lg:px-20 overflow-hidden"
    >
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${HERO_BG_URL})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: isFashion ? 0.22 : 0.4,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B]/95 via-[#0B0B0B]/80 to-[#0B0B0B]" />
        <div className="absolute inset-0 grain-overlay" />
      </div>

      <div className="relative max-w-5xl mx-auto text-center reveal">
        <span className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]">
          {overline}
        </span>

        <h2 className="mt-7 font-serif-display text-[40px] sm:text-6xl md:text-7xl lg:text-8xl leading-[1.02] tracking-tight text-white">
          {heading[0]} <br />
          <span className="italic text-gold-shimmer">{heading[1]}</span>
        </h2>

        <p className="mt-8 max-w-2xl mx-auto text-[15px] md:text-base leading-[1.85] text-white/65 font-light">
          {body}
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={ETSY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEtsy(trackSection)}
            data-testid={isFashion ? "fashion-final-cta-etsy-btn" : "final-cta-etsy-btn"}
            className="btn-gold"
          >
            <span>{ctaLabel}</span>
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="mt-14 flex items-center justify-center gap-3 text-[10px] tracking-[0.42em] uppercase text-white/40">
          <span className="h-px w-8 bg-white/20" />
          {footnote}
          <span className="h-px w-8 bg-white/20" />
        </div>
      </div>
    </section>
  );
}
